var map = {
	"./angry.jpg": "1b9f",
	"./drink.jpg": "323e",
	"./food.jpg": "660d",
	"./grandma.jpg": "f1df",
	"./happy.jpg": "f1a2",
	"./home.jpg": "7b47",
	"./hurt.jpg": "686d",
	"./outside.jpg": "9d3c",
	"./sad.jpg": "5073",
	"./scared.jpg": "3a98",
	"./school.jpg": "5627",
	"./tired.jpg": "6fea",
	"./uncompressed/angry.jpg": "20c8",
	"./uncompressed/drink.jpg": "7563",
	"./uncompressed/food.jpg": "b620",
	"./uncompressed/grandma.jpg": "d76f",
	"./uncompressed/happy.jpg": "3a11",
	"./uncompressed/home.jpg": "d2fe",
	"./uncompressed/hurt.jpg": "f719",
	"./uncompressed/outside.jpg": "05ba",
	"./uncompressed/sad.jpg": "01f7",
	"./uncompressed/scared.jpg": "053b",
	"./uncompressed/school.jpg": "b364",
	"./uncompressed/tired.jpg": "5382"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c701";